/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * MaterialRounded Code.
 * @export
 */
export const ICON_CODE = (
  <svg fill="#000000" height="24px" viewBox="0 0 24 24" width="24px" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M19.2 12L15.3 15.9C15.1128 16.0849 15.0075 16.3369 15.0075 16.6C15.0075 16.8631 15.1128 17.1151 15.3 17.3C15.69 17.69 16.31 17.69 16.7 17.3L21.2899 12.7C21.68 12.31 21.68 11.68 21.2899 11.29L16.7 6.7C16.31 6.31 15.69 6.31 15.3 6.7C15.1128 6.88486 15.0075 7.13695 15.0075 7.4C15.0075 7.66306 15.1128 7.91515 15.3 8.10001L19.2 12ZM4.79996 12L8.69998 15.9C9.09 16.29 9.09 16.91 8.69998 17.3C8.30997 17.69 7.68997 17.69 7.29996 17.3L2.70999 12.7C2.31998 12.31 2.31998 11.68 2.70999 11.29L7.29996 6.7C7.48489 6.51285 7.73697 6.40752 8.00003 6.40752C8.26309 6.40752 8.51517 6.51285 8.69998 6.7C9.09 7.09 9.09 7.71 8.69998 8.09999L4.79996 12Z"
      fill="#707070"
      fillRule="evenodd"
    />
  </svg>
);
